import { availableExperience, explicitContentExperience } from '@/shells/incremental/models/contentExperience';
import { buildChartingRouteLocation, buildChartingLegacyHref } from '@/features/charting-next/utils/chartingLinks';

// Identity comes from the thread API, never from its human-readable title.
export function forumTicker(value) {
  if (typeof value !== 'string') return '';
  const symbol = value.trim();
  return symbol.length <= 80 && !/[\s/\\?#]/.test(symbol) && !Array.from(symbol).some(char => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127) ? symbol.toUpperCase() : '';
}

export function forumStockChartLocation({ ticker, route = {}, preference = 'legacy', user = {} }) {
  const symbol = forumTicker(ticker);
  if (!symbol) return null;
  const experience = availableExperience(explicitContentExperience(route) || preference, user);
  if (experience === 'modern') return buildChartingRouteLocation({ type: 'ticker', value: symbol });
  // Several classic route records share the name Stockchart. A named location
  // resolves to the unparameterized first record and silently loses the ticker.
  // Reuse its existing URL adapter, keeping navigation inside the current SPA.
  const legacy = new URL(buildChartingLegacyHref({ type: 'ticker', value: symbol }), 'https://app.invalid');
  return { path: legacy.pathname + legacy.search };
}
